import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { supabase } from "../../lib/supabaseClient";

// A saved sign-in in this browser. Read synchronously so a returning user's page
// can render straight away instead of waiting on getSession().
function hasStoredSession() {
  try {
    return !!window.localStorage.getItem(supabase.auth.storageKey);
  } catch {
    return false;
  }
}

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // While the session is being restored, render the page for anyone with a saved
  // sign-in — no full-screen "Checking your access…". The page's own data calls
  // wait for the session inside the Supabase client, and sections show their own
  // "Curating projects for you…". If the session turns out to be gone, the
  // redirect below fires; a removed client is still signed out by AuthProvider's
  // allowlist check. Without a saved sign-in there is nothing to wait for.
  if (loading) return hasStoredSession() ? children : null;

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace state={{ from: location }} />;
  }

  return children;
}
